import { create } from 'axios';

const client = create({
  baseURL: window.REACT_APP_CIAM_BACKEND_BASE_URL,
  timeout: window.REACT_APP_TIME_OUT,
});

export default client;
